import React, { useEffect, useState } from 'react'
import { useLanguage } from '../config/language/LanguageContext'
import phone1 from "./../assets/phone-1.png";
import phone2 from "./../assets/phone-2.png";
import phone3 from "./../assets/phone-3.png";

const AboutUs = () => {
    const { locale } = useLanguage();
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);
      useEffect(() => {
        const handleResize = () => {
          setIsSmallScreen(window.innerWidth < 600);
        };
    
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
  return (
   <section id={locale.NAV_BAR.aboutId} className="py-12 bg-white">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <h2 className="text-3xl font-semibold text-gray-800 text-center">
            {locale.ABOUT.heading}
          </h2>
          <p className="text-gray-500 text-center mt-4 max-w-2xl mx-auto">
            {locale.ABOUT.headingPara}
          </p>

          <div className="relative mt-8 bg-purple-100 rounded-2xl p-6 md:p-12 flex items-center justify-between overflow-hidden min-h-[250px] md:min-h-[300px]">
            <div className="flex-1 pl-4 md:pl-8">
              <h3 className="text-xl font-semibold text-gray-800">
                {locale.ABOUT.highlightHeading}
              </h3>
              <p className="text-gray-600 mt-2">{locale.ABOUT.highlightPara}</p>
            </div>

            {!isSmallScreen && (
              <div className="absolute bottom-[-30px] right-0 w-48 md:w-60 lg:w-72 xl:w-80 transform rotate-[-10deg] z-10">
                <img
                  src={phone1}
                  alt="Phone Mockup"
                  className="w-full h-auto object-contain"
                />
              </div>
            )}
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 md:px-6 py-5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
            <div className="bg-orange-50 rounded-2xl p-8 flex flex-col items-center text-center relative min-h-[400px] overflow-hidden">
              <img
                src={phone3}
                alt={locale.ABOUT.cards.left.alt}
                className="-mt-12 w-48 md:w-64 object-contain"
              />
              <h3 className="text-xl font-semibold text-gray-800 mt-6">
                {locale.ABOUT.cards.left.heading.map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </h3>
            </div>

            <div className="bg-blue-50 rounded-2xl p-8 flex flex-col items-center text-center relative min-h-[400px] overflow-hidden">
              <h3 className="text-xl font-semibold text-gray-800 mb-6 py-9">
                {locale.ABOUT.cards.right.heading.map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </h3>
              <img
                src={phone2}
                alt={locale.ABOUT.cards.right.alt}
                className="w-48 md:w-64 object-contain absolute bottom-0"
              />
            </div>
          </div>
        </div>
      </section>
  )
}

export default AboutUs;
